// Extrait du Dashboard Finance — pipeline visuel des phases finance TEF.
// Données : /api/metier/stats/visites-amo
import { BarChart3, Loader2 } from "lucide-react";
import { Badge } from "../../components/ui/badge";
import { useFinanceFetch } from "./useFinanceFetch";

export default function FinancePipelineWidget() {
  const { data, loading, error } = useFinanceFetch("/api/metier/stats/visites-amo");

  if (loading) {
    return (
      <div
        className="rounded-xl p-5 h-full flex items-center justify-center"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      >
        <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} />
      </div>
    );
  }
  if (error) {
    return (
      <div
        className="rounded-xl p-5"
        style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)", color: "var(--oh-text-muted)" }}
      >
        Erreur Pipeline Finance : {error}
      </div>
    );
  }

  const s = data?.stats || {};
  const pipeline = [
    { phase: "Factures AMO émises", count: s.avec_facture || 0, color: "var(--oh-stat-blue-text)" },
    { phase: "Règlements reçus", count: s.avec_reglement || 0, color: "#10b981" },
    { phase: "Visites payées (décaiss.)", count: s.visites_payees || 0, color: "var(--oh-stat-red-text)" },
    { phase: "Visites à payer", count: s.visites_non_payees || 0, color: "var(--oh-stat-amber-text)" },
  ];
  const total = pipeline.reduce((a, b) => a + b.count, 0);

  return (
    <div
      className="rounded-xl p-5 h-full"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="finance-pipeline-widget"
    >
      <h3 className="font-semibold mb-4 flex items-center gap-2" style={{ color: "var(--oh-text)" }}>
        <BarChart3 className="w-4 h-4" style={{ color: "#8b5cf6" }} />
        Pipeline Finance
        <Badge
          className="ml-auto text-xs"
          style={{ background: "var(--oh-bg-surface)", color: "var(--oh-text-secondary)", border: "1px solid var(--oh-border)" }}
        >
          {total} dossiers
        </Badge>
      </h3>
      {total === 0 ? (
        <div className="text-center py-8" style={{ color: "var(--oh-text-muted)" }}>
          Aucun dossier en phase finance
        </div>
      ) : (
        <>
          <div className="flex h-10 rounded-xl overflow-hidden mb-4" style={{ border: "1px solid var(--oh-border)" }}>
            {pipeline.filter((p) => p.count > 0).map((p) => {
              const pct = (p.count / total) * 100;
              return (
                <div
                  key={p.phase}
                  className="relative group flex items-center justify-center transition-all hover:brightness-125"
                  style={{ width: `${Math.max(pct, 3)}%`, backgroundColor: p.color }}
                >
                  {pct > 10 && <span className="text-white text-xs font-bold">{p.count}</span>}
                </div>
              );
            })}
          </div>
          <div className="flex flex-wrap gap-x-4 gap-y-1">
            {pipeline.map((p) => (
              <div key={p.phase} className="flex items-center gap-1.5">
                <div className="w-2.5 h-2.5 rounded-sm" style={{ backgroundColor: p.color }} />
                <span className="text-xs" style={{ color: "var(--oh-text-muted)" }}>{p.phase}</span>
                <span className="text-xs font-medium" style={{ color: p.color }}>{p.count}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
